export const hoursOfOperation = [
  {
    breaks: [],
    openTime: { time: '09:00', hour: 9, minute: 0 },
    closeTime: { time: '21:00', hour: 21, minute: 0 },
    inverted: false,
    isClosed: false,
    isOpen: true
  },
  {
    breaks: [],
    openTime: { time: '09:00', hour: 9, minute: 0 },
    closeTime: { time: '21:00', hour: 21, minute: 0 },
    inverted: false,
    isClosed: false,
    isOpen: true
  },
  {
    breaks: [],
    openTime: { time: '09:00', hour: 9, minute: 0 },
    closeTime: { time: '21:00', hour: 21, minute: 0 },
    inverted: false,
    isClosed: false,
    isOpen: true
  },
  {
    breaks: [],
    openTime: { time: '09:00', hour: 9, minute: 0 },
    closeTime: { time: '21:00', hour: 21, minute: 0 },
    inverted: false,
    isClosed: false,
    isOpen: true
  },
  {
    breaks: [],
    openTime: { time: '09:00', hour: 9, minute: 0 },
    closeTime: { time: '21:00', hour: 21, minute: 0 },
    inverted: false,
    isClosed: false,
    isOpen: true
  },
  {
    breaks: [],
    openTime: { time: '09:00', hour: 9, minute: 0 },
    closeTime: { time: '21:00', hour: 21, minute: 0 },
    inverted: false,
    isClosed: false,
    isOpen: true
  },
  {
    breaks: [],
    openTime: { time: '09:00', hour: 9, minute: 0 },
    closeTime: { time: '21:00', hour: 21, minute: 0 },
    inverted: false,
    isClosed: false,
    isOpen: true
  }
];

export const days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
